import { FC } from "react";
import { Flex, useBreakpointValue } from "@chakra-ui/react";
import {
  HeadingWithHighlight,
  PanelContentContainer,
} from "~/OnboardingApp/components";
import { GetStartedCta } from "./GetStartedCta";
import { StepsConditional } from "./StepsConditional";

export const RightSection: FC = () => {
  const highlightColor = "var(--chakra-colors-newReddish-50)";
  const key =
    useBreakpointValue({
      base: "onboarding.welcomePage.heading.mobile" as const,
      lg: "onboarding.welcomePage.heading.desktop" as const,
    }) ?? ("onboarding.welcomePage.heading.desktop" as const);

  return (
    <PanelContentContainer>
      <Flex
        direction="column"
        gap={{ base: 0, lg: "6rem" }}
        mt={{ base: 0, lg: "6rem" }}
        w="full"
      >
        <HeadingWithHighlight highlightColor={highlightColor} i18nKey={key} />
        <StepsConditional />
        <GetStartedCta />
      </Flex>
    </PanelContentContainer>
  );
};
